import { forwardRef } from "react";
import { PassThroughPropsWithRef } from "../../types";
import cx from "classnames";
import styles from "./DrillDown.module.scss";

/**
 * Props for the DrillDownContent component.
 *
 * @extends PassThroughPropsWithRef<"div">
 */
export type DrillDownContentProps = PassThroughPropsWithRef<"div"> & {};

/**
 * Scrollable content area for DrillDown screens.
 *
 * Contains the main content for a drilldown step. Handles overflow with vertical scrolling.
 *
 * Features:
 * - Automatic scroll behavior for long content
 * - Full width content area
 *
 * @example
 * ```tsx
 * <DrillDown.Content>
 *   <p>Main content for this step.</p>
 * </DrillDown.Content>
 * ```
 */
export const DrillDownContent = forwardRef<
  HTMLDivElement,
  DrillDownContentProps
>((props, ref) => {
  const { className, ...rest } = props;

  return (
    <div {...rest} className={cx(styles["content"], className)} ref={ref}></div>
  );
});

DrillDownContent.displayName = "DrillDownContent";
